import React from 'react';
import { Link } from 'react-router-dom';
import ProductList from './ProductList';
import styles from './HomePage.module.css';

const HomePage: React.FC = () => {
  return (
    <div className={styles.homePage}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            <h1 className={styles.heroTitle}>COME FIND COMFORT FROM WITHIN</h1>
           
            <div className={styles.heroButtons}>
              <Link to="/products" className={styles.shopNowButton}>
                Shop Now
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
